



















import { PreviewTypeEnum } from "@components/change-entity-sequence-number/enums";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class ChangePreviewTypeComponent extends Vue {
  @Prop() value: PreviewTypeEnum;
  @Watch("value")
  valueUpdated() {
    this.innerValue = this.value;
  }

  innerValue: PreviewTypeEnum = PreviewTypeEnum.Table;
  previewTypeEnum = PreviewTypeEnum;

  created() {
    if (this.value) this.innerValue = this.value;
  }

  selectPreview(type: PreviewTypeEnum) {
    this.innerValue = type;
    this.$emit("input", type);
  }

  mounted() {}
}
